import { render, staticRenderFns } from "./r-smart-offer-bundle-piggy.vue?vue&type=template&id=722aba9d"
import script from "./r-smart-offer-bundle-piggy.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-piggy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('722aba9d')) {
      api.createRecord('722aba9d', component.options)
    } else {
      api.reload('722aba9d', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-piggy.vue?vue&type=template&id=722aba9d", function () {
      api.rerender('722aba9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-piggy/r-smart-offer-bundle-piggy.vue"
export default component.exports